export default "__VITE_ASSET__DTbvQko___"